<!--
    by:hansan
-->
<template>
  <section class="app-main" :class="'app-main-' + cutSize"  >
      <router-view :key="$route.path + $route.query.t" />
  </section>
</template>

<script>
    export default {
        name: "appMain",
        props:{
            cutSize: {
            },
        }
    }
</script>

<style scoped lang="less">
    .app-main{
        height: calc(100vh - 50px);
		overflow: auto;
        background: #F2F5F6;
    }
    .app-main-zero{
        width:100vw;
    }
    .app-main-small{
        width: calc(100vw - 50px);
    }
    .app-main-default{
        width: calc(100vw - 190px);
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue